import { render, staticRenderFns } from "./TimetableView.vue?vue&type=template&id=01332ede&scoped=true"
import script from "./TimetableView.vue?vue&type=script&lang=ts"
export * from "./TimetableView.vue?vue&type=script&lang=ts"
import style0 from "./TimetableView.vue?vue&type=style&index=0&id=01332ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01332ede",
  null
  
)

export default component.exports